export const URL_REGEX_STRING =
  '[Hh][Tt][Tt][Pp][Ss]?:\\/\\/(?:(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)(?:\\.(?:[a-zA-Z\u00a1-\uffff0-9]+-?)*[a-zA-Z\u00a1-\uffff0-9]+)*(?:\\.(?:[a-zA-Z\u00a1-\uffff]{2,}))(?::\\d{2,5})?(?:\\/[^\\s]*)?'
export const URL_REGEX_HELPER_TEXT = 'Please provide a valid uri.'

export function titleCase(str) {
  return str
    .replace(/^[-_]*(.)/, (_, char) => char.toUpperCase())
    .replace(/[-_]+(.)/g, (_, char) => ' ' + char.toUpperCase())
}

export function capitalize(str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export function camelCase(str) {
  return str.replace(/-./g, (x) => x[1].toUpperCase())
}

export function hex2rgb(hex) {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `${r},${g},${b}`
}

export function shade(color, amount) {
  return `#${color
    .replace(/^#/, '')
    .replace(/../g, (color) =>
      ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).slice(-2),
    )}`
}
